"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find-index");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _socket = require("socket.io-client");

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _lastMileV = require("@/mixins/last-mile-v2/last-mile-v2");

var _permission = require("@/mixins/permission/permission");

var _idle = require("@/mixins/idle/idle");

var _autoLogout = require("@/mixins/auto-logout/auto-logout");

var _orderDateRange = _interopRequireDefault(require("../components/order-date-range/order-date-range.vue"));

var _orderFilter = _interopRequireDefault(require("../components/order-filter/order-filter.vue"));

var _orderFilterTag = _interopRequireDefault(require("../components/order-filter-tag/order-filter-tag.vue"));

var _orderTable = _interopRequireDefault(require("../components/order-table/order-table.vue"));

var _ganttFilter = _interopRequireDefault(require("../components/gantt-filter/gantt-filter.vue"));

var _ganttPagination = _interopRequireDefault(require("../components/gantt-pagination/gantt-pagination.vue"));

var _ganttChart = _interopRequireDefault(require("../components/gantt-chart/gantt-chart.vue"));

var _planHeader = _interopRequireDefault(require("../components/plan-header/plan-header.vue"));

var _planSearch = _interopRequireDefault(require("../components/plan-search/plan-search.vue"));

var _orderSummary = _interopRequireDefault(require("../components/order-summary/order-summary.vue"));

var _truckSummary = _interopRequireDefault(require("../components/truck-summary/truck-summary.vue"));

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDAutoAssignComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDAutoAssignComponent, _Mixins);

  var _super = _createSuper(LMDAutoAssignComponent);

  function LMDAutoAssignComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDAutoAssignComponent);
    _this = _super.apply(this, arguments);
    _this.isShowFailedOrders = false;
    _this.failedOrders = [];
    _this.isEnableAllTrucks = true;
    _this.selectedPlanId = null;
    _this.initAutoAddedDays = 0;
    _this.timeStepper = 30;
    _this.currentPlanId = null;
    _this.truckCurrentPage = 1;
    _this.truckPageSize = 20;
    _this.socket = null;
    _this.isBlocked = false;
    _this.manualAssignUsername = null;
    _this.isFilterTruck = false;
    _this.isShowEnabledTruck = false;
    _this.isUpdateBufferTrucks = {
      hasValue: false
    };
    _this.isShowUploadCSV = false;
    _this.dataSet = null;
    return _this;
  }

  (0, _createClass2.default)(LMDAutoAssignComponent, [{
    key: "$isOrderFullscreen",
    get: function get() {
      return this.$store.getters['common/isOrderFullscreen'];
    }
  }, {
    key: "planHeaderStyle",
    get: function get() {
      return {
        top: !this.$isFullscreen ? '60px' : 0
      };
    }
  }, {
    key: "planBodyStyle",
    get: function get() {
      var height = '47px';

      if (this.$isFullscreen && !this.$isOrderFullscreen) {
        height = '44px';
      }

      if (this.$isFullscreen && this.$isOrderFullscreen) {
        height = '0';
      }

      return {
        'margin-top': height
      };
    }
  }, {
    key: "beforeRouteLeave",
    value: function beforeRouteLeave(to, from, next) {
      this.confirmUnsavedChanges(to, from, next);
    }
  }, {
    key: "created",
    value: function created() {
      if (window.innerWidth < _variables.default['md-min']) {
        this.$isMobile = true;
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _query;

        var newIndex;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.routes = [];
                this.$setTableLoading(true);
                _context.next = 4;
                return this.$getOrderLocationLists({
                  locationType: this.$defaultLocationType,
                  startTime: this.$startDate,
                  endTime: this.$endDate
                });

              case 4:
                _context.next = 6;
                return this.$getTrucks(true);

              case 6:
                _context.next = 8;
                return this.$initPlan();

              case 8:
                newIndex = this.helper.findIndex(this.$orderFilters, {
                  exactValue: true
                });

                if (!(newIndex >= 0 && this.$orderFilters[newIndex]['value'])) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return this.$getUnassignedOrders();

              case 12:
                _context.next = 16;
                break;

              case 14:
                _context.next = 16;
                return this.$setTableLoading(false);

              case 16:
                this.disableInvalidTrucks(); // new logic 12-12-23

                this.disableTruckList = [];
                this.socket = (0, _socket.io)("".concat(process.env.VUE_APP_API_ROUTING_SOCKET, "/v1/lastmile/planning"), {
                  secure: true,
                  reconnection: true,
                  rejectUnauthorized: false,
                  query: (_query = {}, (0, _defineProperty2.default)(_query, process.env.VUE_APP_CUSTOMER_KEY, this.$userInformation.customerKey), (0, _defineProperty2.default)(_query, "routeName", this.$route.name), (0, _defineProperty2.default)(_query, "userEmail", this.$userInformation.user.name), _query),
                  extraHeaders: (0, _defineProperty2.default)({}, process.env.VUE_APP_SECRET_KEY, process.env.VUE_APP_SECRET_KEY_HASH)
                });
                this.updateSelectedData();

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.routes = [];

      if (this.socket) {
        this.socket.close();
      }
    }
  }, {
    key: "handleAutoAssign",
    value: function () {
      var _handleAutoAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var disabledTrucks, isReuseNoZone, hasNoZoneVehicles;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isAutoAssignLoading = true;
                disabledTrucks = [];

                if (window.localStorage.getItem(this.disableTruckKey)) {
                  disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
                }

                isReuseNoZone = this.$userSetting['default28'];
                hasNoZoneVehicles = this.$trucks.filter(function (truck) {
                  return !truck['hasValidZone'] && !_this2.helper.includes(disabledTrucks, truck['id'].toString());
                });

                if (!(isReuseNoZone && hasNoZoneVehicles.length)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return this.handleAutoAssignReuseNoZone(false);

              case 8:
                _context2.next = 12;
                break;

              case 10:
                _context2.next = 12;
                return this.handleAutoAssignNormal(false);

              case 12:
                this.disableInvalidTrucks();
                this.isAutoAssignLoading = false;

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleAutoAssign() {
        return _handleAutoAssign.apply(this, arguments);
      }

      return handleAutoAssign;
    }()
  }, {
    key: "handleAutoAssignAll",
    value: function () {
      var _handleAutoAssignAll = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var disabledTrucks, isReuseNoZone, hasNoZoneVehicles;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isAutoAssignLoading = true;
                disabledTrucks = [];

                if (window.localStorage.getItem(this.disableTruckKey)) {
                  disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
                }

                isReuseNoZone = this.$userSetting['default28'];
                hasNoZoneVehicles = this.$trucks.filter(function (truck) {
                  return !truck['hasValidZone'] && !_this3.helper.includes(disabledTrucks, truck['id'].toString());
                });

                if (!(isReuseNoZone && hasNoZoneVehicles.length)) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 8;
                return this.handleAutoAssignReuseNoZone(true);

              case 8:
                _context3.next = 12;
                break;

              case 10:
                _context3.next = 12;
                return this.handleAutoAssignNormal(true);

              case 12:
                this.disableInvalidTrucks();
                this.isAutoAssignLoading = false; // await this.savePlan(this.$plan, true, 'ASSIGNALLORDER', true, true);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleAutoAssignAll() {
        return _handleAutoAssignAll.apply(this, arguments);
      }

      return handleAutoAssignAll;
    }()
  }, {
    key: "handleAutoAssignNormal",
    value: function () {
      var _handleAutoAssignNormal = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        var isAutoAssignAll,
            orders,
            autoAssign,
            message,
            trucks,
            invalidOrderIds,
            selectedOrderIds,
            invalidRes,
            noSolutionFoundWithReason,
            _message,
            failedOrders,
            _message2,
            finalOrderIds,
            filteredOutTruckIds,
            plan,
            res2,
            _message3,
            _args4 = arguments;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                isAutoAssignAll = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : false;
                this.logger.info('handleAutoAssignNormal');
                orders = this.$selectedOrders.filter(function (order) {
                  return !_this4.isInvalidOrder(order);
                });
                _context4.next = 5;
                return this.autoAssign({
                  orders: orders,
                  startTime: this.$defaultTime,
                  isAutoAssignAll: isAutoAssignAll
                });

              case 5:
                autoAssign = _context4.sent;

                if (autoAssign) {
                  _context4.next = 10;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.noTrucks'),
                  duration: 5000
                };

                _elementUi.Notification.error(message);

                return _context4.abrupt("return");

              case 10:
                trucks = [];
                invalidOrderIds = [];
                selectedOrderIds = [];
                invalidRes = [];

                if (autoAssign['invalid'] && autoAssign['invalid'].length >= 1) {
                  invalidRes = (0, _toConsumableArray2.default)(autoAssign['invalid']);
                }

                this.failedOrders = [];
                this.$failedOrders = [];
                noSolutionFoundWithReason = (this.helper.get(autoAssign, 'error', null) === 'no solution found' || this.helper.get(autoAssign, 'error', null) === 'no vehicle found') && autoAssign.invalid.length !== 0;

                if (autoAssign && invalidRes.length > 0 && autoAssign['vehicles'] && autoAssign['vehicles'].length || noSolutionFoundWithReason) {
                  _message = {
                    title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                    duration: 5000
                  };

                  if (!noSolutionFoundWithReason) {
                    _elementUi.Notification.success(_message);
                  } // NOTE: fix grouping logic is on backend


                  failedOrders = invalidRes.map(function (irData) {
                    selectedOrderIds.push(irData['orderId']);
                    return {
                      code: irData['code'] || '',
                      type: irData['type'] || '',
                      reason: irData['reason'] || '',
                      orderId: irData['orderId'] || [],
                      shipmentReference: irData['shipmentReference'] || [],
                      plateNumber: irData['plateNumber'] || [],
                      vehicleId: irData['vehicleId'] || []
                    };
                  }); // invalidOrderIds = this.helper.flatten(failedOrders.map(i => i.orderId));

                  invalidOrderIds = (0, _toConsumableArray2.default)(autoAssign['invalidOrder']);
                  this.handleFailedOrders({
                    isShowFailedOrders: true,
                    failedOrders: failedOrders
                  });
                  this.$pagination = _objectSpread(_objectSpread({}, this.$pagination), {}, {
                    currentPage: 1
                  });
                  this.logger.info('handleAutoAssignNormal - Set pagination', JSON.stringify(this.$pagination));
                }

                if (!(this.helper.get(autoAssign, 'error', null) === 'no solution found' || this.helper.get(autoAssign, 'error', null) === 'no vehicle found')) {
                  _context4.next = 24;
                  break;
                }

                _message2 = {
                  title: this.$i18n.t('planning.messages.noSolution'),
                  duration: 5000
                };

                _elementUi.Notification.error(_message2);

                _context4.next = 51;
                break;

              case 24:
                if (!(autoAssign && autoAssign['vehicles'] && autoAssign['vehicles'].length)) {
                  _context4.next = 49;
                  break;
                }

                finalOrderIds = [];
                filteredOutTruckIds = [];
                autoAssign['vehicles'].forEach(function (vehicle) {
                  var truckObj = _this4.getTruckInPlan(vehicle.truckId);

                  if (vehicle.orderId && vehicle.orderId.length >= 1) {
                    if (vehicle.type === 'MANUALASSIGN' && !_this4.helper.isUndefined(truckObj)) {
                      finalOrderIds = _this4.helper.uniq([].concat((0, _toConsumableArray2.default)(finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId), (0, _toConsumableArray2.default)(truckObj['orderId'])));
                    } else {
                      finalOrderIds = _this4.helper.uniq([].concat((0, _toConsumableArray2.default)(finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId)));
                    }
                  }

                  if (vehicle.routes && vehicle.routes.length > 0) {
                    filteredOutTruckIds.push(vehicle.truckId);
                    var nOrderIds = [];
                    vehicle.routes.map(function (route) {
                      nOrderIds = [].concat((0, _toConsumableArray2.default)(nOrderIds), (0, _toConsumableArray2.default)(route['orderId']));
                      return route;
                    });
                    trucks.push(_objectSpread(_objectSpread({}, vehicle), {}, {
                      orderId: (0, _toConsumableArray2.default)(new Set(nOrderIds)),
                      locked: false
                    }));
                  }
                });

                if (trucks.length > 0) {
                  this.$anyChanges = true;
                }

                finalOrderIds = (0, _toConsumableArray2.default)(new Set(finalOrderIds));
                plan = this.helper.cloneDeep(this.$plan);
                plan['trucks'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['trucks'].filter(function (i) {
                  return !_this4.helper.includes(filteredOutTruckIds, i.truckId);
                })), trucks), 'truckId');

                if (!isAutoAssignAll) {
                  _context4.next = 40;
                  break;
                }

                if (!(autoAssign['summary'] && autoAssign['summary']['orderId'])) {
                  _context4.next = 38;
                  break;
                }

                _context4.next = 36;
                return this.lastMileDeliveryAPI.getOrdersInPlan({
                  orderId: autoAssign['summary']['orderId']
                });

              case 36:
                res2 = _context4.sent;
                plan['orders'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['orders']), (0, _toConsumableArray2.default)(this.helper.get(res2, 'data.orders', []))).filter(function (o) {
                  return !invalidOrderIds.includes(o['id']);
                }), 'id');

              case 38:
                _context4.next = 41;
                break;

              case 40:
                plan['orders'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['orders']), (0, _toConsumableArray2.default)(orders)).filter(function (o) {
                  return !invalidOrderIds.includes(o['id']);
                }), 'id');

              case 41:
                this.$setPlan({
                  plan: plan
                });
                this.$selectedOrders = this.$selectedOrders.filter(function (i) {
                  return _this4.helper.includes(selectedOrderIds, i['id']);
                });
                this.$excludedOrders = this.helper.uniq((0, _toConsumableArray2.default)(plan['orders'].map(function (o) {
                  return o['id'];
                })).filter(function (id) {
                  return !invalidOrderIds.includes(id);
                }));
                this.logger.info('handleAutoAssignNormal - Get Unassigned Orders');
                _context4.next = 47;
                return this.$getUnassignedOrders();

              case 47:
                _context4.next = 51;
                break;

              case 49:
                _message3 = {
                  title: this.$i18n.t('planning.messages.noTrucks'),
                  duration: 5000
                };

                _elementUi.Notification.error(_message3);

              case 51:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleAutoAssignNormal() {
        return _handleAutoAssignNormal.apply(this, arguments);
      }

      return handleAutoAssignNormal;
    }()
    /**
     * Auto assign and auto assign reuse no zone response has exclusivity traits
     * */

  }, {
    key: "handleAutoAssignReuseNoZone",
    value: function () {
      var _handleAutoAssignReuseNoZone = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this5 = this;

        var isAutoAssignAll,
            orders,
            autoAssign,
            trucks,
            invalidOrders,
            finalOrderIds,
            invalidOrderIds,
            filteredOutTruckIds,
            plan,
            autoAssignReuseNoZone,
            selectedOrderIds,
            invalidRes,
            message,
            failedOrders,
            _message4,
            _finalOrderIds,
            _invalidOrderIds,
            _filteredOutTruckIds,
            _plan,
            _message5,
            _args5 = arguments;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                isAutoAssignAll = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : false;
                this.logger.info('handleAutoAssignReuseNoZone');
                orders = this.$selectedOrders.filter(function (order) {
                  return !_this5.isInvalidOrder(order);
                });
                _context5.next = 5;
                return this.autoAssign({
                  orders: orders,
                  startTime: this.$defaultTime,
                  isReuseNoZone: true,
                  isAutoAssignAll: isAutoAssignAll
                });

              case 5:
                autoAssign = _context5.sent;
                trucks = []; // NOTE: allow to continue even if first assignment failed

                /*if (
                  this.helper.get(autoAssign, 'error', null) === 'no solution found' ||
                  this.helper.get(autoAssign, 'error', null) === 'no vehicle found'
                ) {
                  const message: ElNotificationOptions = {
                    title: this.$i18n.t('planning.messages.noSolution'),
                    duration: 5000,
                  } as ElNotificationOptions;
                       Notification.error(message);
                       return;
                }*/

                invalidOrders = [];

                if (autoAssign === null || this.helper.get(autoAssign, 'error', null) === 'no solution found' || this.helper.get(autoAssign, 'error', null) === 'no vehicle found') {
                  invalidOrders = (0, _toConsumableArray2.default)(orders);
                } // NOTE: old implemenation

                /* if (autoAssign && autoAssign['invalid'].length > 0 && autoAssign['vehicles'] && autoAssign['vehicles'].length) {
                  autoAssign['invalid'].forEach((item) => {
                    item.orderId.forEach((id) => {
                      const order = orders.find((o) => o['id'] === id);
                           if (order) {
                        invalidOrders.push(order);
                      }
                    });
                  });
                } */


                if (autoAssign && autoAssign['invalidOrder'].length > 0 && autoAssign['vehicles'] && autoAssign['vehicles'].length) {
                  invalidOrders = orders.filter(function (o) {
                    return autoAssign['invalidOrder'].includes(o['id']);
                  });
                }

                if (autoAssign && autoAssign['vehicles'] && autoAssign['vehicles'].length) {
                  finalOrderIds = [];
                  invalidOrderIds = [];
                  filteredOutTruckIds = [];
                  autoAssign['vehicles'].forEach(function (vehicle) {
                    var truckObj = _this5.getTruckInPlan(vehicle.truckId);

                    if (vehicle.orderId && vehicle.orderId.length >= 1) {
                      if (vehicle.type === 'MANUALASSIGN' && !_this5.helper.isUndefined(truckObj)) {
                        finalOrderIds = _this5.helper.uniq([].concat((0, _toConsumableArray2.default)(finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId), (0, _toConsumableArray2.default)(truckObj['orderId'])));
                      } else {
                        finalOrderIds = _this5.helper.uniq([].concat((0, _toConsumableArray2.default)(finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId)));
                      }
                    }

                    if (vehicle.routes && vehicle.routes.length > 0) {
                      filteredOutTruckIds.push(vehicle.truckId);
                      var nOrderIds = [];
                      vehicle.routes.map(function (route) {
                        nOrderIds = [].concat((0, _toConsumableArray2.default)(nOrderIds), (0, _toConsumableArray2.default)(route['orderId']));
                        return route;
                      });
                      trucks.push(_objectSpread(_objectSpread({}, vehicle), {}, {
                        orderId: (0, _toConsumableArray2.default)(new Set(nOrderIds)),
                        locked: false
                      }));
                    }
                  });

                  if (trucks.length > 0) {
                    this.$anyChanges = true;
                  }

                  finalOrderIds = (0, _toConsumableArray2.default)(new Set(finalOrderIds)); // invalidOrderIds = [...new Set(this.helper.flatten(invalidOrders.map((item) => item['id'])))];

                  invalidOrderIds = (0, _toConsumableArray2.default)(autoAssign['invalidOrder']);
                  plan = this.helper.cloneDeep(this.$plan);
                  plan['orders'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['orders']), (0, _toConsumableArray2.default)(orders)).filter(function (o) {
                    return !invalidOrderIds.includes(o['id']);
                  }), 'id');
                  plan['trucks'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['trucks'].filter(function (i) {
                    return !_this5.helper.includes(filteredOutTruckIds, i.truckId);
                  })), trucks), 'truckId');
                  this.$setPlan({
                    plan: plan
                  });
                }

                if (!(invalidOrders.length >= 1)) {
                  _context5.next = 49;
                  break;
                }

                _context5.next = 14;
                return this.autoAssignReuseNoZone({
                  orders: invalidOrders,
                  startTime: this.$defaultTime
                });

              case 14:
                autoAssignReuseNoZone = _context5.sent;
                selectedOrderIds = [];
                invalidRes = [];

                if (autoAssignReuseNoZone['invalid'] && autoAssignReuseNoZone['invalid'].length >= 1) {
                  invalidRes = (0, _toConsumableArray2.default)(autoAssignReuseNoZone['invalid']);
                }

                this.failedOrders = [];
                this.$failedOrders = [];

                if (autoAssignReuseNoZone && invalidRes.length > 0 && autoAssignReuseNoZone['vehicles'] && autoAssignReuseNoZone['vehicles'].length) {
                  message = {
                    title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                    duration: 5000
                  };

                  _elementUi.Notification.success(message); // NOTE: fix grouping logic is on backend


                  failedOrders = invalidRes.map(function (irData) {
                    selectedOrderIds.push(irData['orderId']);
                    return {
                      code: irData['code'] || '',
                      type: irData['type'] || '',
                      reason: irData['reason'] || '',
                      orderId: irData['orderId'] || [],
                      shipmentReference: irData['shipmentReference'] || [],
                      plateNumber: irData['plateNumber'] || [],
                      vehicleId: irData['vehicleId'] || []
                    };
                  });
                  this.handleFailedOrders({
                    isShowFailedOrders: true,
                    failedOrders: failedOrders
                  });
                  this.$pagination = _objectSpread(_objectSpread({}, this.$pagination), {}, {
                    currentPage: 1
                  });
                  this.logger.info('handleAutoAssignReuseNoZone - Set pagination', JSON.stringify(this.$pagination));
                }

                if (!(this.helper.get(autoAssignReuseNoZone, 'error', null) === 'no solution found' || this.helper.get(autoAssignReuseNoZone, 'error', null) === 'no vehicle found')) {
                  _context5.next = 26;
                  break;
                }

                _message4 = {
                  title: this.$i18n.t('planning.messages.noSolution'),
                  duration: 5000
                };

                _elementUi.Notification.error(_message4);

                _context5.next = 47;
                break;

              case 26:
                if (!(autoAssignReuseNoZone && autoAssignReuseNoZone['vehicles'] && autoAssignReuseNoZone['vehicles'].length)) {
                  _context5.next = 45;
                  break;
                }

                _finalOrderIds = [];
                _invalidOrderIds = [];
                _filteredOutTruckIds = [];
                autoAssignReuseNoZone['vehicles'].forEach(function (vehicle) {
                  var truckObj = _this5.getTruckInPlan(vehicle.truckId);

                  if (vehicle.orderId && vehicle.orderId.length >= 1) {
                    if (vehicle.type === 'MANUALASSIGN' && !_this5.helper.isUndefined(truckObj)) {
                      _finalOrderIds = _this5.helper.uniq([].concat((0, _toConsumableArray2.default)(_finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId), (0, _toConsumableArray2.default)(truckObj['orderId'])));
                    } else {
                      _finalOrderIds = _this5.helper.uniq([].concat((0, _toConsumableArray2.default)(_finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId)));
                    }
                  }

                  if (vehicle.routes && vehicle.routes.length > 0) {
                    _filteredOutTruckIds.push(vehicle.truckId);

                    var nOrderIds = [];
                    vehicle.routes.map(function (route) {
                      nOrderIds = [].concat((0, _toConsumableArray2.default)(nOrderIds), (0, _toConsumableArray2.default)(route['orderId']));
                      return route;
                    });
                    trucks.push(_objectSpread(_objectSpread({}, vehicle), {}, {
                      orderId: (0, _toConsumableArray2.default)(new Set(nOrderIds)),
                      locked: false
                    }));
                  }
                });

                if (trucks.length > 0) {
                  this.$anyChanges = true;
                }

                _finalOrderIds = (0, _toConsumableArray2.default)(new Set(_finalOrderIds));
                _invalidOrderIds = (0, _toConsumableArray2.default)(autoAssignReuseNoZone['invalidOrder']);
                _plan = this.helper.cloneDeep(this.$plan);
                _plan['orders'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(_plan['orders']), (0, _toConsumableArray2.default)(orders)).filter(function (o) {
                  return !_invalidOrderIds.includes(o['id']);
                }), 'id');
                _plan['trucks'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(_plan['trucks'].filter(function (i) {
                  return !_this5.helper.includes(_filteredOutTruckIds, i.truckId);
                })), trucks), 'truckId');
                this.$setPlan({
                  plan: _plan
                });
                this.$selectedOrders = this.$selectedOrders.filter(function (i) {
                  return _this5.helper.includes(selectedOrderIds, i['id']);
                });
                this.$excludedOrders = this.helper.uniq((0, _toConsumableArray2.default)(this.$plan.orders.map(function (o) {
                  return o['id'];
                })).filter(function (id) {
                  return !_invalidOrderIds.includes(id);
                }));
                this.logger.info('handleAutoAssignReuseNoZone - Get Unassigned Orders');
                _context5.next = 43;
                return this.$getUnassignedOrders();

              case 43:
                _context5.next = 47;
                break;

              case 45:
                _message5 = {
                  title: this.$i18n.t('planning.messages.noTrucks'),
                  duration: 5000
                };

                _elementUi.Notification.error(_message5);

              case 47:
                _context5.next = 55;
                break;

              case 49:
                this.$selectedOrders = [];
                this.$includedOrders = [];
                this.$excludedOrders = this.helper.uniq((0, _toConsumableArray2.default)(this.$plan.orders.map(function (o) {
                  return o['id'];
                })));
                this.logger.info('handleAutoAssignReuseNoZone 2 - Get Unassigned Orders');
                _context5.next = 55;
                return this.$getUnassignedOrders();

              case 55:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function handleAutoAssignReuseNoZone() {
        return _handleAutoAssignReuseNoZone.apply(this, arguments);
      }

      return handleAutoAssignReuseNoZone;
    }()
  }, {
    key: "handleEnableAllTrucks",
    value: function handleEnableAllTrucks() {
      this.isEnableAllTrucks = true;
    }
  }, {
    key: "handleDisableAllTrucks",
    value: function handleDisableAllTrucks() {
      this.isEnableAllTrucks = false;
    }
  }, {
    key: "handleSearchValueIsFound",
    value: function handleSearchValueIsFound(newVal) {
      this.selectedPlanId = newVal;
    }
  }, {
    key: "recalculateTimeList",
    value: function recalculateTimeList(newVal) {
      this.initAutoAddedDays = newVal;
    }
  }, {
    key: "handleTimeStepperChanges",
    value: function handleTimeStepperChanges(newVal) {
      this.timeStepper = newVal;
    }
  }, {
    key: "handleFailedOrders",
    value: function handleFailedOrders(_ref) {
      var isShowFailedOrders = _ref.isShowFailedOrders,
          failedOrders = _ref.failedOrders;
      this.isShowFailedOrders = isShowFailedOrders;
      this.failedOrders = this.helper.orderBy(failedOrders.map(function (fOData) {
        fOData['finalCode'] = fOData['code'] || '';
        fOData['finalPriority'] = '';

        if (fOData['code']) {
          var codeArr = fOData['code'].toString().split('-');

          if (codeArr.length === 2) {
            fOData['finalPriority'] = codeArr[0] || '';
            fOData['finalCode'] = codeArr[1] || '';
          }
        }

        return fOData;
      }), ['finalPriority'], ['asc']);
      this.$failedOrders = failedOrders;
    }
  }, {
    key: "updateSelectedData",
    value: function updateSelectedData() {
      var _this6 = this;

      this.socket.on('connect', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.logger.info('socket-connected', _this6.socket.id);

                _this6.$socketId = _this6.socket.id;
                _this6.isBlocked = false;
                _this6.isOccupied = false;

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      })));
      this.socket.on('connected', /*#__PURE__*/function () {
        var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(res) {
          var userData;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  userData = _this6.helper.get(res, 'data.userData', []);

                  if (userData && userData.length >= 1) {
                    userData = userData.filter(function (uData) {
                      return Number(uData.companyId) === Number(_this6.$userInformation.company.id);
                    });

                    if (userData[0] && userData[0]['routeName'] !== _this6.$route.name && userData[0]['userId'] !== _this6.$socketId) {
                      _this6.isBlocked = true;
                      _this6.manualAssignUsername = userData[0]['userName'].split('@')[0];
                      _this6.isOccupied = true;
                      _this6.occupyingUsername = userData[0]['userName'].split('@')[0];
                      _this6.occupyingRoute = userData[0]['routeName'];
                    } else {
                      _this6.isBlocked = false;
                      _this6.isOccupied = false;
                    }
                  } else {
                    _this6.isBlocked = false;
                    _this6.isOccupied = false;
                  }

                  _this6.logger.info('Socket - Connected', res);

                  if (res.data && res.status === 'success') {
                    _this6.$GLOBAL_ACTIVE_USERS = (0, _toConsumableArray2.default)(userData);
                    _this6.$GLOBAL_SELECTED_ORDERS = res.data.orderData.length >= 1 ? res.data.orderData.filter(function (oData) {
                      return oData['userId'] !== _this6.$socketId;
                    }) : [];
                    _this6.$GLOBAL_SELECTED_TRUCKS = res.data.truckData.length >= 1 ? res.data.truckData.filter(function (tData) {
                      return tData['userId'] !== _this6.$socketId;
                    }) : [];
                  }

                case 4:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
      this.socket.on('saved', function (res) {
        _this6.logger.info('Socket - Saved', res);

        if (res.status === 'success' && res.data && res.data.code === _this6.$planDate) {
          _this6.updatePlanFromSocket(res.data);
        }
      });
      this.socket.on('error', /*#__PURE__*/function () {
        var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(res) {
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _this6.logger.info('socket-error');

                case 1:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }());
      this.socket.on('connect_error', /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(res) {
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _this6.logger.info('socket-connect_error');

                case 1:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getReasonFailMessage",
    value: function getReasonFailMessage(reason) {
      return this.$t("planning.autoAssignInvalidCodes.".concat(reason));
    }
  }, {
    key: "getReasonFailParam",
    value: function getReasonFailParam() {
      var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var reasonArr = reason.split('~');
      return this.helper.get(reasonArr, '1', '-').trim();
    }
  }, {
    key: "handleTruckSizeChange",
    value: function handleTruckSizeChange(newVal) {
      this.truckPageSize = newVal;
    }
  }, {
    key: "handleTruckCurrentChange",
    value: function handleTruckCurrentChange(newVal) {
      this.truckCurrentPage = newVal;
    }
  }, {
    key: "handleIsFilterTruckChanges",
    value: function handleIsFilterTruckChanges(newVal) {
      this.isFilterTruck = newVal;
    }
  }, {
    key: "handleIsShowEnabledTruckChanges",
    value: function handleIsShowEnabledTruckChanges(newVal) {
      this.isShowEnabledTruck = newVal;
    }
  }, {
    key: "handleUpdateBufferTrucks",
    value: function handleUpdateBufferTrucks(newVal) {
      this.isUpdateBufferTrucks = newVal;
    }
  }, {
    key: "onDataSetChanges",
    value: function onDataSetChanges() {
      var file = this.$refs.dataSet;

      if (typeof file !== 'undefined') {
        this.dataSet = file.files[0];
      }
    }
  }, {
    key: "handleAssignCSVError",
    value: function handleAssignCSVError() {
      var message = {
        title: this.$i18n.t('planning.messages.noSolution'),
        duration: 5000
      };

      _elementUi.Notification.error(message);

      this.isAutoAssignLoading = false;
      this.isShowUploadCSV = false;
    }
  }, {
    key: "csvAssignToTruck",
    value: function () {
      var _csvAssignToTruck = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var formData, res, data;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.isAutoAssignLoading = true;

                if (!this.helper.isUndefined(this.dataSet)) {
                  _context10.next = 4;
                  break;
                }

                this.handleAssignCSVError();
                return _context10.abrupt("return");

              case 4:
                formData = new FormData();
                formData.append('userEmail', this.$userInformation.user.name);
                formData.append('dateTime', "".concat(this.$planDate, " ").concat(this.$userSetting.default6));
                formData.append('timeWindow', this.$userSetting.default2);
                formData.append('data', this.dataSet);
                _context10.next = 11;
                return this.lastMileDeliveryAPI.csvAssign(formData, {
                  code: this.$planDate
                });

              case 11:
                res = _context10.sent;
                data = this.helper.get(res, 'data', null);
                _context10.next = 15;
                return this.handleCSVAssign(data);

              case 15:
                this.isShowUploadCSV = false;
                this.isAutoAssignLoading = false;

              case 17:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function csvAssignToTruck() {
        return _csvAssignToTruck.apply(this, arguments);
      }

      return csvAssignToTruck;
    }()
  }, {
    key: "handleCSVAssign",
    value: function () {
      var _handleCSVAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(autoAssign) {
        var _this7 = this;

        var orders, trucks, invalidReasons, selectedOrderIds, invalidRes, message, failedOrders, _message6, finalOrderIds, invalidOrderIds, filteredOutTruckIds, plan, _message7;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                orders = this.helper.get(autoAssign, 'orders', []);

                if (orders.length) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt("return");

              case 3:
                trucks = [];
                invalidReasons = [];
                selectedOrderIds = [];
                invalidRes = [];

                if (autoAssign['invalid'] && autoAssign['invalid'].length >= 1) {
                  invalidRes = (0, _toConsumableArray2.default)(autoAssign['invalid']);
                }

                this.failedOrders = [];
                this.$failedOrders = [];

                if (autoAssign && invalidRes.length > 0 && autoAssign['vehicles'] && autoAssign['vehicles'].length) {
                  message = {
                    title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                    duration: 5000
                  };

                  _elementUi.Notification.success(message); // NOTE: fix grouping logic is on backend


                  failedOrders = invalidRes.map(function (irData) {
                    selectedOrderIds.push(irData['orderId']);
                    return {
                      code: irData['code'] || '',
                      type: irData['type'] || '',
                      reason: irData['reason'] || '',
                      orderId: irData['orderId'] || [],
                      shipmentReference: irData['shipmentReference'] || [],
                      plateNumber: irData['plateNumber'] || [],
                      vehicleId: irData['vehicleId'] || []
                    };
                  });
                  this.handleFailedOrders({
                    isShowFailedOrders: true,
                    failedOrders: failedOrders
                  });
                  this.$pagination = _objectSpread(_objectSpread({}, this.$pagination), {}, {
                    currentPage: 1
                  });
                  this.logger.info('handleCSVAssign - Set pagination', JSON.stringify(this.$pagination));
                }

                if (!(this.helper.get(autoAssign, 'error', null) === 'no solution found' || this.helper.get(autoAssign, 'error', null) === 'no vehicle found')) {
                  _context11.next = 16;
                  break;
                }

                _message6 = {
                  title: this.$i18n.t('planning.messages.noSolution'),
                  duration: 5000
                };

                _elementUi.Notification.error(_message6);

                _context11.next = 37;
                break;

              case 16:
                if (!(autoAssign && autoAssign['vehicles'] && autoAssign['vehicles'].length)) {
                  _context11.next = 35;
                  break;
                }

                finalOrderIds = [];
                invalidOrderIds = [];
                filteredOutTruckIds = [];
                autoAssign['vehicles'].forEach(function (vehicle) {
                  var truckObj = _this7.getTruckInPlan(vehicle.truckId);

                  if (vehicle.orderId && vehicle.orderId.length >= 1) {
                    if (vehicle.type === 'MANUALASSIGN' && !_this7.helper.isUndefined(truckObj)) {
                      finalOrderIds = _this7.helper.uniq([].concat((0, _toConsumableArray2.default)(finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId), (0, _toConsumableArray2.default)(truckObj['orderId'])));
                    } else {
                      finalOrderIds = _this7.helper.uniq([].concat((0, _toConsumableArray2.default)(finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId)));
                    }
                  }

                  if (vehicle.routes && vehicle.routes.length > 0) {
                    filteredOutTruckIds.push(vehicle.truckId);
                    var nOrderIds = [];
                    vehicle.routes.map(function (route) {
                      nOrderIds = [].concat((0, _toConsumableArray2.default)(nOrderIds), (0, _toConsumableArray2.default)(route['orderId']));
                      return route;
                    });
                    trucks.push(_objectSpread(_objectSpread({}, vehicle), {}, {
                      orderId: (0, _toConsumableArray2.default)(new Set(nOrderIds)),
                      locked: false,
                      hasUpdate: true
                    }));
                  }
                });

                if (trucks.length > 0) {
                  this.$anyChanges = true;
                }

                finalOrderIds = (0, _toConsumableArray2.default)(new Set(finalOrderIds));
                invalidOrderIds = (0, _toConsumableArray2.default)(autoAssign['invalidOrder']);
                plan = this.helper.cloneDeep(this.$plan);
                plan['orders'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['orders']), (0, _toConsumableArray2.default)(orders)).filter(function (o) {
                  return !invalidOrderIds.includes(o['id']);
                }), 'id');
                plan['trucks'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['trucks'].filter(function (i) {
                  return !_this7.helper.includes(filteredOutTruckIds, i.truckId);
                })), trucks), 'truckId');
                this.$setPlan({
                  plan: plan
                });
                this.$selectedOrders = this.$selectedOrders.filter(function (i) {
                  return _this7.helper.includes(selectedOrderIds, i['id']);
                });
                this.$excludedOrders = this.helper.uniq((0, _toConsumableArray2.default)(this.$plan.orders.map(function (o) {
                  return o['id'];
                })).filter(function (id) {
                  return !invalidOrderIds.includes(id);
                }));
                /*const planOrderIds = this.$plan.orders.map((i) => i['id']);
                this.$includedOrders = this.helper
                  .uniq([
                    ...this.$includedOrders,
                    ...invalidOrderIds.filter((iId) => !this.helper.includes(finalOrderIds, iId))
                  ])
                  .filter((orderId) => !this.helper.includes(planOrderIds, orderId));*/

                this.logger.info('handleCSVAssign - Get Unassigned Orders');
                _context11.next = 33;
                return this.$getUnassignedOrders();

              case 33:
                _context11.next = 37;
                break;

              case 35:
                _message7 = {
                  title: this.$i18n.t('planning.messages.noTrucks'),
                  duration: 5000
                };

                _elementUi.Notification.error(_message7);

              case 37:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function handleCSVAssign(_x4) {
        return _handleCSVAssign.apply(this, arguments);
      }

      return handleCSVAssign;
    }()
  }]);
  return LMDAutoAssignComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _lastMileV.LastMileDeliveryMixin, _idle.IdleMixin, _autoLogout.AutoLogoutMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], LMDAutoAssignComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], LMDAutoAssignComponent.prototype, "$isFullscreen", void 0);
LMDAutoAssignComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDAutoAssignComponent',
  components: {
    'order-date-range': _orderDateRange.default,
    'order-filter': _orderFilter.default,
    'order-filter-tag': _orderFilterTag.default,
    'order-table': _orderTable.default,
    'gantt-filter': _ganttFilter.default,
    'gantt-pagination': _ganttPagination.default,
    'gantt-chart': _ganttChart.default,
    'plan-header': _planHeader.default,
    'plan-search': _planSearch.default,
    'order-summary': _orderSummary.default,
    'truck-summary': _truckSummary.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-dialog': _elementUi.Dialog,
    'el-button': _elementUi.Button
  }
})], LMDAutoAssignComponent);
var _default = LMDAutoAssignComponent;
exports.default = _default;